import { GridCustomCellProps } from '@progress/kendo-react-grid';
import * as React from 'react';
import { Trip, useTrack } from '.';
import { openWindowPerc } from '../../services/openWindow';
import { ILink } from '../../types/link';
import SplitOrderSummary from '../Order/SplitOrderSummary';
import { getServiceTeamName } from 'utils/utils';

const ReferenceCell = (props: GridCustomCellProps) => {
  const { toggleExpand } = useTrack();
  const [showSplitSummary, setShowSplitSummary] = React.useState(false);

  const trip = props.dataItem as Trip;

  const openFront = (threadId: string) => {
    if (threadId.startsWith("cnv_") || threadId.startsWith("msg_")) {
      const win = window.open(`https://app.frontapp.com/open/${threadId}`, '_blank');
      win.focus();
    }
  }

  return (
    <td {...props.tdProps} style={{ maxWidth: 200 }}>
      {showSplitSummary && <SplitOrderSummary OrderID={trip.OrderID} onClose={() => setShowSplitSummary(false)} />}
      <a
        href="#"
        style={{ color: '#007bff' }}
        onClick={(e) => {
          openWindowPerc(trip.Links.find((x: ILink) => x.Name === 'NewLoad').Link);
          e.preventDefault();
        }}
      >
        {trip.OrderNumber}
      </a>
      {trip.SplitLabel &&
        <React.Fragment>
          &nbsp;
          <a
            href="#"
            style={{ color: '#007bff' }}
            onClick={(e) => {
              setShowSplitSummary(true);
              e.preventDefault();
            }}
          >
            {trip.SplitLabel}
          </a>
        </React.Fragment>
      }

      &nbsp;&nbsp;&nbsp;
      {trip.Links.find((x: ILink) => x.Name === 'TripProfile') && <a
        href="#"
        style={{ color: '#007bff' }}
        onClick={(e) => {
          openWindowPerc(trip.Links.find((x: ILink) => x.Name === 'TripProfile').Link);
          e.preventDefault();
        }}
      >
        {trip.TripNumber}
      </a>}

      {trip.HasEventNotification && <React.Fragment>
        &nbsp;&nbsp;&nbsp;<a
          href="#"
          style={{ color: 'red' }}
          onClick={(e) => {
            toggleExpand(trip.OrderID);
            e.preventDefault();
          }}
        >
          S-EN
        </a>
      </React.Fragment>}
      <br />
      {trip.ReferenceNumber1}&nbsp;&nbsp;
      {trip.ReferenceNumber2 && <a
        href="#"
        style={{ color: '#007bff' }}
        onClick={(e) => {
          openFront(trip.ReferenceNumber2);
          e.preventDefault();
        }}
      >
        {trip.ReferenceNumber2}&nbsp;&nbsp;
      </a>}
      {trip.ReferenceNumber3?.toUpperCase()}
      <br />
      {getServiceTeamName(trip.ServiceTeamID)}
      {trip.IsCritical && <>
        &nbsp;&nbsp;<span style={{ color: "red" }}>CRITICAL</span>
      </>}
      {trip.HazMat && <>
        &nbsp;&nbsp;<span style={{ color: "red" }}>HAZMAT</span>
      </>}
    </td>
  );
}
export default React.memo(ReferenceCell, (prev, next) => prev.dataItem.Hash === next.dataItem.Hash);